import clsx from "clsx";
import { useCart } from "../../contexts/cart.jsx";
import {
  HeartPlus,
  MinusIcon,
  PlusIcon,
  ShoppingCart,
  Trash,
  X,
} from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Button } from "~/components/ui/button.jsx";
import { Input } from "~/components/ui/input.jsx";
import { router } from "@inertiajs/react";
import { line_item_path } from "~/routes.js";

export default function ({ product }) {
  const { addLineItem, deleteLineItem, setLineItemQuantity, cart } = useCart();
  const lineItem = cart.line_items.find(
    (li) => li.variant_id === product.master.id
  );
  const { total_on_hand } = product;

  const quantityInputRef = useRef(null);

  const getQuantity = () => {
    return lineItem?.quantity || 1;
  };

  const [quantity, setQuantity] = useState(() => getQuantity());

  useEffect(() => {
    // if (lineItem) {
    //   if (quantity !== lineItem.quantity) {
    //     setLineItemQuantity(lineItem, quantity)
    //   }
    // } else {
    //   addLineItem(product, quantity)
    // }
  }, [quantity]);

  const handleQuantityChange = (e) => {};
  return (
    <div className="space-y-2">
      <div className="space-x-1 lg:space-x-2 flex w-full items-center">
        <Button
          className="h-14 w-full"
          variant={ lineItem ? "secondary" : "outline"}
          onClick={async () => {
            if (lineItem) {
              deleteLineItem(lineItem);
            } else {
              addLineItem(product, 1);
            }
          }}
        >
          {lineItem ? (
            <>
              <X /> Убрать
            </>
          ) : (
            <>
              <ShoppingCart /> В корзину
            </>
          )}
        </Button>

        <div className="hidden">
          <div className="flex h-10 items-center space-x-1 lg:space-x-2">
            <Button
              size="icon"
              className="size-9 lg:size-11"
              variant="outline"
              onClick={() => {
                quantityInputRef.current.value +
                  quantityInputRef.current.value -
                  1;
                // quantityInputRef.target.value = quantityInputRef.target.value - 1
              }}
            >
              <MinusIcon size={40} />
            </Button>
            <Input
              disabled
              type="text"
              className="size-9 lg:size-11 text-center"
              value={quantity}
              onChange={handleQuantityChange}
              ref={quantityInputRef}
            />
            {/*<input type="text" className="rounded w-8 border-none text-center" value={quantity} />*/}
            <Button
              size="icon"
              className="size-9 lg:size-11"
              variant="outline"
              onClick={() => {
                // const qty = parseInt(quantityInputRef.current.value)
                // quantityInputRef.current.value = qty + 1

                setQuantity(quantity + 1);
                // quantityInputRef.current.target.value = quantityInputRef.current.target.value + 1
              }}
            >
              <PlusIcon size={40} />
            </Button>
          </div>
        </div>

        <div className="hidden">
          <Button size="icon" className="size-9 lg:size-11" variant="ghost">
            <HeartPlus size={40} />
          </Button>
        </div>
      </div>
    </div>
  );
}
